import { DateTime } from "luxon";

export enum DeviceStatus {
  Connected = 1,
  Disconnected = 2,
  AuthFailure = 3,
  VersionFailure = 4,
  Disabled = 5,
}

export enum DeviceType {
  Fidelix = 0,
  Sigfox = 1,
  EDI = 2,
  Curves = 3,
  Datahub = 4,
}

export enum DeviceCapabilities {
  RemoteAccess = "RemoteAccess",
  EditValue = "EditValue",
}

export class DeviceLite {
  id: number;
  name: string;
  type: DeviceType;
  building: string;
  ipAddress: string;
  levelId: number;
  externalId: string;
  graphicsId?: number;
  isCalendarHidden: boolean;

  constructor(device: DeviceLite) {
    this.id = device.id;
    this.name = device.name;
    this.type = device.type;
    this.building = device.building;
    this.ipAddress = device.ipAddress;
    this.levelId = device.levelId;
    this.externalId = device.externalId;
    this.graphicsId = device.graphicsId;
    this.isCalendarHidden = device.isCalendarHidden;
  }
}

export type DeviceResponse = {
  id: number;
  name: string;
  type: DeviceType;
  building: string;
  ipAddress: string;
  levelId: number;
  externalId: string;
  graphicsId?: number;
  isCalendarHidden: boolean;
  status: DeviceStatus;
  version: string;
  lastOnlineAt: string | null;
};

export class DeviceState {
  id: number;
  status: DeviceStatus;
  version: string | null;
  lastOnlineAt: DateTime | null;
  constructor(data: {
    id: number;
    status: DeviceStatus;
    version: string | null;
    lastOnlineAt: string | null;
  }) {
    this.id = data.id;
    this.status = data.status;
    this.version = data.version;
    this.lastOnlineAt = data.lastOnlineAt
      ? DateTime.fromISO(data.lastOnlineAt)
      : null;
  }
}

export class Device extends DeviceLite {
  status: DeviceStatus;
  version: string;
  lastOnlineAt: DateTime | null;
  constructor(data: DeviceResponse) {
    super(data);
    this.status = data.status;
    this.version = data.version;
    this.lastOnlineAt = data.lastOnlineAt
      ? DateTime.fromISO(data.lastOnlineAt)
      : null;
  }
}

export class DeviceStatusHistory {
  event: number;
  timestamp: string;
  buildingName: string;
  device: DeviceLite;
  constructor(device: DeviceStatusHistory) {
    this.event = device.event;
    this.timestamp = device.timestamp;
    this.buildingName = device.buildingName;
    this.device = device.device;
  }
}
